import CryptoJS from 'crypto-js'

const encryptKey = '3@Q$v9%L!7t^Y5-sP*8dF#zK2mX6cR4gH~J1nB0uA?VwS]Z+eT{G<W}lN'
const joinSymbol = '&'

const varifyPath = [
  { '/api/v1/workflow/update': 'post' },
  { '/api/v1/workflow/publish': 'post' },
  { '/api/v1/workflow/publish': 'put' },
  { '/api/v1/assistant': 'put' },
  { '/api/v1/assistant': 'post' },
  { '/api/v1/workflow/create': 'post' },
  { '/api/v1/assistant/message_notify': 'post' },
  { '/api/v1/knowledge/create': 'post' },
  { '/api/v1/knowledge/upgrade': 'post' },
  { '/api/v1/tools/create': 'post' },
  { '/api/v1/tools/publish': 'post' },
  { '/api/v1/workflow/create': 'post' }
]

function requestNeedVerify(method, urlPath = '') {
  console.log('requestNeedVerify :>> ', method, urlPath)
  let needVerify = false

  for (const perPath of varifyPath) {
    const router = Object.keys(perPath)[0]
    if (urlPath.startsWith(router) && method === perPath[router]) {
      needVerify = true
      break
    }
  }

  return needVerify
}

function getDataWaitToMd5(params) {
  return encryptKey + joinSymbol + params
}

function md5Encrypt(data) {
  const param = getDataWaitToMd5(data)
  console.log(`param info: ${param}`)

  // Use CryptoJS to create an MD5 hash
  return CryptoJS.MD5(param).toString()
}

export { md5Encrypt, requestNeedVerify }
